<script>
export default {};
</script>

<template>
    <span class="Hint">
        i
        <div class="Popup">
            <slot></slot>
        </div>
    </span>
</template>

<style lang="stylus" scoped>
@import '../../stylus/vars.styl'

.Hint
    position relative
    display inline-flex
    justify-content center
    align-items center
    width 25px
    height 25px
    font-size 18px
    border-radius 50%
    font-weight 700
    border 2px solid $cBorder
    color $cBorder
    cursor default
    margin 0 10px
    z-index 9999
    .Popup
        position absolute
        top 100%
        right 100%
        padding 20px
        background #fff
        border 2px solid $cBorder
        color $cPrimary
        font-size 12px
        font-weight 400
        transform: translate(50%, -50%) scale(0);
        transition .3s all
        z-index 9999
        text-transform none
    &:hover
        .Popup
            transform: translate(0%, 0%) scale(1);
    &.Darken
        color darken($cBorder, 15%)
        border-color darken($cBorder, 15%)
    &.Small
        font-size 12px
        width 15px
        height 15px
        border-width 1px
        font-weight 500
    &.NoWrap
        .Popup
            white-space nowrap
    &.Abs
        position absolute
    &.Full
        .Popup
            width 350px
    &.PositionTop
        .Popup
            top auto
            right auto
            left 50%
            bottom 100%
            transform: translate(-50%, 50%) scale(0);
        &:hover
            .Popup
                transform: translate(-50%, 0) scale(1);
</style>


